module.exports = __webpack_public_path__ + "static/alexSite-c7a7fbd86e83e026e9f19b398e973dcc.gif";